<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >会员 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.username"
                  placeholder="请输入会员姓名/手机号"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10">所属公司 : </span>
              <div class="width300">
                <el-select v-model="searchData.factoryId" clearable>
                  <el-option
                    v-for="item in classifyList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >试卷名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10">考核状态 : </span>
              <div class="width300">
                <el-select v-model="searchData.state" clearable>
                  <el-option
                    v-for="item in OPassStatus"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>
          </div>
        </div>
      </template>

      <template slot="mainImage" slot-scope="{ row }">
        <div class="flex align-items">
          <el-image
            style="width: 60px; height: 60px"
            :src="row.avatarUrl"
            :preview-src-list="[row.avatarUrl]"
          >
          </el-image>
          <div class="marginLeft10">
            <div>{{ row.username }}</div>
            <div>{{ row.phone }}</div>
          </div>
        </div>
      </template>
      <template slot="score" slot-scope="{ row }">
        <div>{{ row.score }}/{{ row.totalScore }}</div>
      </template>
      <template slot="rightNum" slot-scope="{ row }">
        <div>{{ row.rightNum }}/{{ row.totalNum }}</div>
      </template>
      <template slot="state" slot-scope="{ row }">
        <div>{{ MPassStatus[row.state] }}</div>
      </template>
      <template slot="useTime" slot-scope="{ row }">
        <div>{{ Math.floor(row.useTime / 60) }}分{{ row.useTime % 60 }}秒</div>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleAnswer(row.id)"
          >查看答题情况</el-button
        >
      </template>
    </avue-crud>
    <tableForm ref="tableFormRef" />
  </div>
</template>

<script>
import { questionExamList } from "@/api/question/record";
import { MPassStatus, OPassStatus } from "@/enums/beCurrent/EBeCurrent";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import { manageFactoryList } from "@/api/user/manage";
import tableForm from "./tableForm.vue";
export default {
  name: "index",
  components: {
    tableForm,
  },
  data() {
    return {
      classifyList: [],
      OPassStatus,
      MPassStatus,
      searchData: {
        factoryId: "",
        name: "",
        state: "",
        username: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: true,
        column: [
          {
            label: "记录ID",
            prop: "id",
          },
          {
            label: "会员信息",
            prop: "mainImage",
          },
          {
            label: "所属公司",
            prop: "factoryName",
          },
          {
            label: "试卷名称",
            prop: "name",
          },
          {
            label: "得分/总分",
            prop: "score",
          },
          {
            label: "正确题数/总数",
            prop: "rightNum",
          },
          {
            label: "考核状态",
            prop: "state",
          },
          {
            label: "考试用时",
            prop: "useTime",
          },

          {
            label: "提交时间",
            prop: "commitTime",
          },
        ],
      },
      dialogVisible: false,
      equityClassifyList: [], //权益分类
    };
  },
  created() {
    this.getClassifyList();
  },
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        // path: this.$route.path,
        // searchData: this.searchData,
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchForm.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchForm.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchForm.createTime;
      this.showLoading = true;
      questionExamList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchForm,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 重置form
    resetForm() {
      this.form = {
        factoryId: "",
        name: "",
        state: "",
        username: "",
      };
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 权益分类
    getClassifyList() {
      manageFactoryList({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data;
        }
      });
    },
    //切换是否显示
    handleSwitch(e, id) {
      videoManageHomeUpdate({
        id: id,
        isHome: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },
    handleAnswer(id) {
      this.$refs.tableFormRef.open(id);
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
